import React from 'react';
import LinkItem, { LinkItemProps } from '../LinkItem';
import Box from '@sendsprint/ui-react/dist/components/Box';
import Text from '@sendsprint/ui-react/dist/components/Text';
import { getActiveLink } from '@src/layouts/dashboard/utils/getActiveLink';
import { useLocation } from 'react-router-dom';

export interface AsideBlockProps {
  sectionHeader?: string;
  links: Omit<LinkItemProps, 'active'>[];
  handleNavClose?: () => void;
}

const AsideBlock = ({ links, handleNavClose, sectionHeader }: AsideBlockProps) => {
  const location = useLocation();

  return (
    <Box>
      {sectionHeader && (
        <Text className="ss-uppercase ss-mb-1 ss-font-semibold">{sectionHeader}</Text>
      )}
      {links.map((link) => (
        <LinkItem
          onLinkClick={handleNavClose}
          active={getActiveLink(link.to, location.pathname)}
          key={link.label}
          {...link}
        />
      ))}
    </Box>
  );
};

export default AsideBlock;
